import { OpportunityPropsSchema } from '../../graph-schemas/sales';
import type { NodeDefinition } from './base-crm';

export const SALES_NODES: Record<string, NodeDefinition> = {
  Opportunity: {
    type: 'Opportunity',
    schema: OpportunityPropsSchema,
    displayName: 'Opportunity',
    displayNamePlural: 'Opportunities',
    icon: 'BriefcaseBusiness',
    color: '#8b5cf6',
    formFields: [
      { key: 'name', label: 'Name', type: 'text', required: true },
      {
        key: 'organization',
        label: 'Organization',
        type: 'lookup',
        required: true,
        lookupConfig: {
          nodeType: 'Organization',
          edgeType: 'OPPORTUNITY_FOR',
          direction: 'outgoing',
        },
      },
      {
        key: 'primary_contact',
        label: 'Primary Contact',
        type: 'lookup',
        lookupConfig: {
          nodeType: 'Person',
          edgeType: 'HAS_CONTACT',
          direction: 'outgoing',
          edgeProps: { role: 'primary' },
        },
      },
      { key: 'organization.name', label: 'Organization', type: 'text' },
      { key: 'primary_contact.name', label: 'Primary Contact', type: 'text' },
      { key: 'stage', label: 'Stage', type: 'select', required: true, picklistName: 'opportunity_stage' },
      { key: 'amount', label: 'Amount', type: 'number', required: true, format: 'currency' },
      { key: 'expected_close_date', label: 'Expected Close', type: 'date' },
      { key: 'owner_user_id', label: 'Owner', type: 'user' },
    ],
    pmnEnabled: true,
    listViewIncludes: [
      {
        edgeType: 'OPPORTUNITY_FOR',
        direction: 'outgoing',
        nodeTypes: ['Organization'],
        as: 'organization',
      },
      {
        edgeType: 'HAS_CONTACT',
        direction: 'outgoing',
        nodeTypes: ['Person'],
        as: 'primary_contact',
        includeEdgeProps: true,
        edgeFilter: { role: 'primary' },
      },
    ],
    relationshipSections: [
      {
        sectionLabel: 'Company',
        icon: 'Building2',
        edgeTypes: ['OPPORTUNITY_FOR'],
        direction: 'outgoing',
        renderMode: 'grid',
        columns: [
          { field: 'name', headerName: 'Company', flex: 2, minWidth: 150, source: 'node', editable: false },
          { field: 'industry', headerName: 'Industry', flex: 1, minWidth: 120, source: 'node', editable: false },
        ],
      },
      {
        sectionLabel: 'Contacts',
        icon: 'Users',
        edgeTypes: ['HAS_CONTACT'],
        direction: 'outgoing',
        renderMode: 'grid',
        columns: [
          { field: 'name', headerName: 'Name', flex: 2, minWidth: 150, source: 'node', editable: false },
          { field: 'role', headerName: 'Role', width: 120, source: 'edge', editable: true, editType: 'text' },
        ],
      },
      {
        sectionLabel: 'Activities',
        icon: 'Activity',
        edgeTypes: ['RELATED_TO'],
        direction: 'incoming',
        renderMode: 'grid',
        columns: [
          { field: 'type', headerName: 'Type', width: 100, source: 'node', editable: false },
          { field: 'subject', headerName: 'Subject', flex: 2, minWidth: 150, source: 'node', editable: false },
          { field: 'occurred_at', headerName: 'Date', width: 120, type: 'datetime', source: 'node', editable: false },
        ],
      },
    ],
  },
};
